import { createGlobalStyle } from 'styled-components';

import LufgaLight from '@/assets/lufga/LufgaLight.ttf';
import LufgaRegular from '@/assets/lufga/LufgaRegular.ttf';
import LufgaMedium from '@/assets/lufga/LufgaMedium.ttf';
import LufgaSemiBold from '@/assets/lufga/LufgaSemiBold.ttf';
import LufgaBold from '@/assets/lufga/LufgaBold.ttf';

export const GlobalStyle = createGlobalStyle`
  :root {
      ${(props) =>
        props.theme.breakpoints
          .map((bp: number, index: number) => {
            if (index === 0) return `font-size: ${props.theme.rootFontSize};`;

            return `@media (min-width: ${bp}px) {font-size: calc(${props.theme.rootFontSize} + ${index}px);}`;
          })
          .join('\n')}
  }

  @font-face {
    font-family: 'Lufga';
    src: url(${LufgaLight}) format('truetype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Lufga';
    src: url(${LufgaRegular}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Lufga';
    src: url(${LufgaMedium}) format('truetype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Lufga';
    src: url(${LufgaSemiBold}) format('truetype');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'Lufga';
    src: url(${LufgaBold}) format('truetype');
    font-weight: 700;
    font-style: normal;
  }

  body {
    line-height: normal;
    transition: none;
    font-family: 'Lufga', sans-serif;
  }
`;
